import { option } from "fp-ts";
import { pipe } from "fp-ts/lib/pipeable";

export const booleanFold = <T>(optionToFold: option.None | option.Some<T>) => pipe(
    optionToFold,
    option.fold(
        () => false,
        () => true
    )
);